var map = {
	"./aufsteller.jpg": 5093,
	"./david.png": 6950,
	"./elstner.jpg": 1889,
	"./gerlach.png": 5458,
	"./gesamt.jpg": 3521,
	"./lighthouse.jpeg": 735,
	"./schmidt.jpg": 8224,
	"./togo.jpg": 2067,
	"./togoPzr.png": 9607,
	"./xxl.jpg": 6036,
	"./zacoach.jpg": 6607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5004;